import React, { memo, useContext, useMemo } from 'react';
import cx from 'classnames';

import { PreviewComponentProps } from '../../EmailTemplatePreview';
import EditorContext, { EditorContextProps } from '../../../Editor/Context';
import Cta from '../Components/Cta';
import ChatBubble from '../Components/ChatBubble';
import VideoPreview from '../Components/VideoPreview';
import Sender from '../Components/Sender';
import { getTimestamp } from '~/utils/date';
import Disclaimer from '../Components/Disclaimer';
import Footer from '../Components/Footer';
import Banner from '../Components/Banner';
import { useVmPlan } from '~/react-hooks/use-plans';

const Html3 = memo(
  ({
    image,
    name,
    bio,
    playerImage,
    theme,
    children,
    hidePreviewTag,
    bannerContent,
    disclaimerContent,
  }: PreviewComponentProps) => {
    const editorContext: EditorContextProps = useContext(EditorContext);
    const { isFreePlan } = useVmPlan();

    const { preview } = editorContext;
    const isMobile = useMemo(() => {
      return preview === 'mobile';
    }, [preview]);

    return (
      <div
        className={cx('rounded-md border border-solid', {
          'border-white': isMobile,
          'border-neutral-300 mx-14': !isMobile,
        })}
      >
        {name && <Banner sender={name} content={bannerContent} />}
        <div className={`m-auto w-[${isMobile ? '250px' : '350px'}]`}>
          <ChatBubble showArrow chatBubbleClassName='px-4 pt-3 pb-1 text-black'>
            {children}
          </ChatBubble>
          <VideoPreview
            thumbnail={playerImage}
            hidePreviewTag={hidePreviewTag}
            className='pt-5'
          />
          <Cta
            textColor={theme?.secondaryColor}
            bgColor={theme?.primaryColor}
            className='pt-5'
          />
          <Sender
            image={image}
            name={name}
            bio={bio}
            subtitle={`Recorded on ${getTimestamp()} UTC`}
            senderClassName='!font-bold text-neutral-900'
            bioClassName='!font-bold text-neutral-900'
          />
        </div>
        <Disclaimer className='py-6 text-black' contents={disclaimerContent} />
        {isFreePlan && <Footer />}
      </div>
    );
  }
);

export default Html3;
